module.exports = __webpack_public_path__ + "img/female_accountant.87e9c0e8.svg";